import { render } from "./RegisterHeader.vue?vue&type=template&id=c1e86f0a"
import script from "./RegisterHeader.vue?vue&type=script&lang=js"
export * from "./RegisterHeader.vue?vue&type=script&lang=js"

import "./RegisterHeader.vue?vue&type=style&index=0&id=c1e86f0a&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Auth/views/Register/components/RegisterHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c1e86f0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c1e86f0a', __exports__)) {
    api.reload('c1e86f0a', __exports__)
  }
  
  module.hot.accept("./RegisterHeader.vue?vue&type=template&id=c1e86f0a", () => {
    api.rerender('c1e86f0a', render)
  })

}


export default __exports__